import {Button} from "@mui/material";
import React from "react";
import {RegionSelector} from "../RegionSelector";
import TextFieldStyled from "../TextFieldStyled";
import {WorkshopCategorySelector} from "@/components/workshops/WorkshopCategorySelector";
import OnlineOfflineSelector from "@/components/OnlineOfflineSelector";
import {WorkshopOrganizerSelector} from "@/components/workshops/WorkshopOrganizerSelector";

export const WorkshopFilterContainer = ({
                                            filterMobile = false,
                                            handleInputChanged,
                                            handleFilterChanged,
                                            handleOnlineOfflineChanged,
                                            onCancel,
                                        }) => {

    return (
        <>
            <TextFieldStyled
                label="Workshops durchsuchen"
                name="filter"
                onChange={handleFilterChanged}
            />

            <WorkshopCategorySelector label="Art des Workshops" name="category" onChange={handleInputChanged}/>
            <OnlineOfflineSelector name="online" label="Online oder lokal" onChange={handleOnlineOfflineChanged}/>
            <WorkshopOrganizerSelector label="Organisiert von" name="workshop_organizer" onChange={handleInputChanged}/>
            <RegionSelector label="Region" name="region" placeholder="Alle Workshops" onChange={handleInputChanged}/>

            {filterMobile && (
                <Button
                    fullWidth
                    color="secondary"
                    variant="contained"
                    onClick={onCancel}
                >
                    Filter schließen
                </Button>
            )}
        </>
    );
};
